import React from 'react';
import styled from 'styled-components';
import { colors, fonts } from '../theme';
import KimeraCargando from '../assets/Kimera_Cargando.png';
import { StyledPageContainer, PageContent } from './Pages.styles';

const NotFoundImage = styled.img`
  width: 100%;
  max-width: 400px;
  height: auto;
  margin-bottom: 2rem;
`;

const NotFoundText = styled.h1`
  color: ${colors.white};
  font-family: ${fonts.families.primary};
  font-size: 4rem;
  font-weight: ${fonts.weights.bold};
  text-transform: ${fonts.textTransform.uppercase};
  letter-spacing: ${fonts.letterSpacing.wide};
  margin: 0;
`;

const NotFoundPage: React.FC = () => {
  return (
    <StyledPageContainer>
      <PageContent>
        <NotFoundImage src={KimeraCargando} alt="Kimera" />
        <NotFoundText>NOT FOUND</NotFoundText>
      </PageContent>
    </StyledPageContainer>
  );
};

export default NotFoundPage;
